import React, {Component} from 'react';
import {Image} from 'react-bootstrap';
import './result.css';
import {connect} from "react-redux";
import Check from '../../resources/images/check.svg';
import FingerPrint from '../../resources/images/fingerprint.svg';
import Signature from '../../resources/images/signature.svg';
import FacialVerification from '../../resources/images/face-verification.svg';
import FrontCard from '../../resources/images/front-card.svg';
import NotaryDeclaration from '../../resources/images/notary-declaration.svg';
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';
import TitleComponent from '../../components/title/TitleComponent';


class Result extends Component {

    getFinishButton = () => {
        if (!this.props.stepInfo.isOnlyView) {
            return (
                        <FooterContainer>
                            <MainButton
                                text={'Finalizar'}
                                onClick={this.props.nextStep}
                             />
                        </FooterContainer>
            );
        }
    };


    getResume = () => {
        let title = 'RESUMEN';

        return (
            <div className={'result page-layout'}>
                <PageWithFooter footer={this.getFinishButton()}>
                <div>
                    <div className='title-container'>
                        <div className='title-text'>
                            <TitleComponent subtitle bolder black>Resumen del proceso</TitleComponent>
                        </div>
                        <p className='text-resume'>Se ha finalizado con éxito el proceso de firma</p>
                    </div>
                    <div className='resume-row'>
                        <div className={'image-container'} >
                            <Image
                                src={FacialVerification}
                                className={'resume-image'}
                            />
                        </div>
                        <div className={'text-container'}>
                            <h2>Reconocimiento facial</h2>
                        </div>
                        <div className={'check-container'} >
                            <Image
                                src={Check}
                                className={'check'}
                                />
                        </div>

                    </div>
                    <div className='resume-row'>
                        <div className={'image-container'} >
                            <Image
                                src={FrontCard}
                                className={'resume-image'}
                            />
                        </div>
                        <div className={'text-container'} >
                            <h2>Firma de la cédula</h2>
                        </div>
                        <div className={'check-container'} >
                            <Image
                                src={Check}
                                className={'check'}
                                />
                        </div>
                    </div>
                    <div className='resume-row'>
                        <div className={'image-container'} >
                            <Image
                                src={Signature}
                                className={'resume-image'}
                            />
                        </div>
                        <div className={'text-container'} >
                            <h2>Firma digital</h2>
                        </div>
                        <div className={'check-container'} >
                            <Image
                                src={Check}
                                className={'check'}
                                />
                        </div>
                    </div>
                    <div className='resume-row'>
                        <div className={'image-container'} >
                            <Image
                                src={FingerPrint}
                                className={'resume-image'}
                            />
                        </div>
                        <div className={'text-container'} >
                            <h2>Huella de la cédula</h2>
                        </div>
                        <div className={'check-container'} >
                            <Image
                                src={Check}
                                className={'check'}
                                />
                        </div>
                    </div>
                    { this.props.stepInfo.is_telepresence_type === true ?
                    <div className='resume-row'>
                        <div className={'image-container'} >
                            <Image
                                src={NotaryDeclaration}
                                className={'resume-image'}
                            />
                        </div>
                        <div className={'text-container'} >
                            <h2>Declaración telepresencia</h2>
                        </div>
                        <div className={'check-container'} >
                            <Image
                                src={Check}
                                className={'check'}
                                />
                        </div>
                    </div>: ''
                    }
                </div>
                </PageWithFooter>
            </div>
        );
    };

    render() {
        return this.getResume();
    }
}


const mapStateToProps = state => {
    return {
        code: state.code,
        stepInfo: state.stepInfo,
        stepData: state.stepData,
        multiple: state.multiple,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Result);
